import { useRouter } from 'next/router';

import { useCallback } from 'react';

import { assign } from '../services';
import { isPC } from '../../../util/window/getDevice';

export function useLink() {
  const router = useRouter();

  return useCallback((url: string) => {
    if (url.includes('.php')) {
      assign(url);
    } else {
      void router.push(isPC ? url : `/m${url}`, url);
    }
  }, [router]);
}
